import store from 'local-storage-fallback'

export function getItem(key) {
  return store.getItem(key)
}

export function setItem(key, value) {
  return store.setItem(key, value)
}

export function removeItem(key) {
  return store.removeItem(key)
}

export function clear() {
  return store.clear()
}
